import { z } from "zod";
import { GeocodeSourceSchema, } from "../geo/geocode.model.js";
export const CustomerServiceAddressManagerSchema = z.object({
    familyName: z.string().trim().min(1).max(255),
    email: z.string().trim().email().max(255),
    firstName: z.string().trim().max(255).nullable().optional(),
    phone: z.string().trim().max(255).nullable().optional(),
    gender: z.enum(["mr", "mrs"]).nullable().optional(),
});
const coordinate = z
    .union([z.string(), z.number().finite().transform(String)])
    .nullable()
    .optional();
export const CustomerServiceAddressInputSchema = z.object({
    id: z.string().uuid(),
    manager: CustomerServiceAddressManagerSchema.nullable().optional(),
    label: z.string().max(255).nullable().optional(),
    address: z.string().trim().min(1).max(255),
    address2: z.string().max(255).nullable().optional(),
    city: z.string().trim().min(1).max(255),
    zip: z.string().trim().min(1).max(255),
    latitude: coordinate,
    longitude: coordinate,
    geocodeSource: GeocodeSourceSchema.nullable().optional(),
});
export const CustomerServiceAddressChangesPayloadSchema = z
    .object({
    version: z.number().int().nonnegative(),
    create: z.array(CustomerServiceAddressInputSchema),
    update: z.array(CustomerServiceAddressInputSchema),
    deleteIds: z.array(z.string().uuid()),
    defaultAddressId: z.string().uuid().nullable(),
    managerUpdates: z
        .array(z
        .object({
        id: z.string().uuid(),
        manager: CustomerServiceAddressManagerSchema.nullable(),
    })
        .strict())
        .optional(),
})
    .superRefine((value, context) => {
    const ids = [
        ...value.create.map(({ id }) => id),
        ...value.update.map(({ id }) => id),
        ...value.deleteIds,
        ...(value.managerUpdates ?? []).map(({ id }) => id),
    ];
    if (new Set(ids.map((id) => id.toLowerCase())).size !== ids.length) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Une adresse ne peut porter plusieurs opérations.",
        });
    }
    if (value.defaultAddressId && value.deleteIds.includes(value.defaultAddressId)) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["defaultAddressId"],
            message: "L'adresse par défaut ne peut pas être supprimée.",
        });
    }
});
//# sourceMappingURL=service-address.js.map